import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    RouterModule.forRoot([
      {
        path: 'booking',
        loadChildren: () => import('./booking/booking.module').then(m => m.BookingModule)
      },
      {
        path: 'sbm',
        loadChildren: () => import('./sbm/sbm.module').then(m => m.SbmModule)
      },
      {
        path: 'self-checkin',
        loadChildren: () => import('./my-self/my-self.module').then(m => m.MySelfModule)
      },
      {
        path: 'myself',
        loadChildren: () => import('./my-self-mobile/my-self-mobile.module').then(m => m.MySelfMobileModule)
      },
      {
        path: 'totem',
        loadChildren: () => import('./totem/totem.module').then(m => m.TotemModule)
      },
      {
        path: 'voucher',
        loadChildren: () => import('./voucher/voucher.module').then(m => m.VoucherModule)
      },
      {
        path: 'voucher-acquisto',
        loadChildren: () => import('./voucher-acquisto/voucher-acquisto.module').then(m => m.VoucherAcquistoModule)
      },
      {
        path: 'dms',
        loadChildren: () => import('./dms/dms.module').then(m => m.DmsModule)
      },
      {
        path: 'accessori',
        loadChildren: () => import('./accessori/accessori.module').then(m => m.AccessoriModule)
      },
      { path: '**', redirectTo: 'sbm' }
    ])
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }